module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/brave.2671b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/brave.jpg
// module id = nC6w
// module chunks = 0